import { useTranslation } from 'react-i18next';
import { Skeleton } from '../../components/Skeleton';
import { SrOnly } from '../../components/SrOnly';
import { StackLarge } from '../../components/Stack';
import {
  Table,
  TableOverflow,
  TableWrapper,
  Tbody,
  Td,
  TdFoldout,
  TdGroup,
  Th,
  Thead,
  Tr,
} from '../../components/Table';
import { DummyOverflow, DummyOverflowList, DummyOverflowListItem, Wrapper } from './wrapper';

const SkeletonListPage = () => {
  const { t } = useTranslation(['other']);

  return (
    <>
      <SrOnly>{t('skeletonLoading.content', { ns: 'other' })}</SrOnly>
      <Wrapper>
        <StackLarge>
          <Skeleton $width="100%" $height="52px" />
        </StackLarge>
        <StackLarge>
          <DummyOverflow>
            <DummyOverflowList>
              <DummyOverflowListItem>
                <Skeleton $width="90px" $height="40px" />
              </DummyOverflowListItem>
              <DummyOverflowListItem>
                <Skeleton $width="90px" $height="40px" />
              </DummyOverflowListItem>
              <DummyOverflowListItem>
                <Skeleton $width="135px" $height="40px" />
              </DummyOverflowListItem>
              <DummyOverflowListItem>
                <Skeleton $width="160px" $height="40px" />
              </DummyOverflowListItem>
            </DummyOverflowList>
          </DummyOverflow>
        </StackLarge>
        <StackLarge>
          <Skeleton $width="105px" $height="21px" />
        </StackLarge>
        <StackLarge>
          <TableWrapper>
            <TableOverflow>
              <Table>
                <Thead>
                  <Tr>
                    <Th>
                      <Skeleton $width="80px" $height="20px" />
                    </Th>
                    <Th>
                      <Skeleton $width="40px" $height="20px" />
                    </Th>
                    <Th>
                      <Skeleton $width="90px" $height="20px" />
                    </Th>
                    <Th $isMinimal />
                  </Tr>
                </Thead>
                <Tbody>
                  <Tr>
                    <Td>
                      <Skeleton $width="120px" $height="24px" />
                    </Td>
                    <TdGroup>
                      <Td>
                        <Skeleton $width="80px" $height="24px" />
                      </Td>
                      <Td>
                        <Skeleton $width="60px" $height="24px" />
                      </Td>
                    </TdGroup>
                    <TdFoldout>
                      <Skeleton $width="32px" $height="32px" />
                    </TdFoldout>
                  </Tr>
                  <Tr>
                    <Td>
                      <Skeleton $width="100px" $height="24px" />
                    </Td>
                    <TdGroup>
                      <Td>
                        <Skeleton $width="100px" $height="24px" />
                      </Td>
                      <Td>
                        <Skeleton $width="80px" $height="24px" />
                      </Td>
                    </TdGroup>
                    <TdFoldout>
                      <Skeleton $width="32px" $height="32px" />
                    </TdFoldout>
                  </Tr>
                  <Tr>
                    <Td>
                      <Skeleton $width="80px" $height="24px" />
                    </Td>
                    <TdGroup>
                      <Td>
                        <Skeleton $width="60px" $height="24px" />
                      </Td>
                      <Td>
                        <Skeleton $width="70px" $height="24px" />
                      </Td>
                    </TdGroup>
                    <TdFoldout>
                      <Skeleton $width="32px" $height="32px" />
                    </TdFoldout>
                  </Tr>
                </Tbody>
              </Table>
            </TableOverflow>
          </TableWrapper>
        </StackLarge>
      </Wrapper>
    </>
  );
};

export default SkeletonListPage;
